// Названия способов доставки и ручных статусов «Доставки продавцом» — те же
// слова, что в кабинете продавца (sales.carrier, sales.selfDelivery.steps),
// чтобы продавец и покупатель говорили об одном и том же одинаково.

export const CARRIER_NAMES: Record<string, string> = {
	sdek: "СДЭК",
	flat: "Доставка OSMIX",
	self: "Доставка продавцом",
	pecom: "ПЭК",
	dellin: "Деловые линии",
	seller_pickup: "Самовывоз из магазина",
};

export const carrierName = (carrier?: string): string => (carrier && CARRIER_NAMES[carrier]) || "Доставка OSMIX";

// Ручные статусы своей доставки продавца — по порядку, как в карточке заказа
// кабинета: Ожидает → Принят → Передан курьеру → Доставлен.
export const SELF_DELIVERY_STEPS = [
	{ code: "new", label: "Ожидает" },
	{ code: "accepted", label: "Принят" },
	{ code: "handed_to_courier", label: "Передан курьеру" },
	{ code: "delivered", label: "Доставлен" },
] as const;

export const selfStepIndex = (statusCode?: string): number => {
	const i = SELF_DELIVERY_STEPS.findIndex((s) => s.code === statusCode);
	return i < 0 ? 0 : i;
};

// Отслеживание отправления СДЭК на сайте перевозчика.
export const trackingUrl = (carrier: string | undefined, number: string | undefined): string | undefined =>
	carrier === "sdek" && number ? `https://www.cdek.ru/ru/tracking?order_id=${encodeURIComponent(number)}` : undefined;
